var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('IconBtn',_vm._g({attrs:{"icons":_vm.icon},on:{"click":_vm.changePrintMode},model:{value:(_vm.printMode),callback:function ($$v) {_vm.printMode=$$v},expression:"printMode"}},on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])])}
var staticRenderFns = []

export { render, staticRenderFns }